export interface ApiPostRequest<REQ> {
  apiUrl: string;
  data: REQ;
  token?: string;
}

export const apiPostRequest = async <REQ, RES>(request: ApiPostRequest<REQ>): Promise<RES> => {
  const headers: Record<string, string> = {
    accept: 'application/json',
    'content-type': 'application/json',
  };
  if (request.token) {
    headers['Authorization'] = `Bearer ${request.token}`;
  }

  const response = await fetch(request.apiUrl, {
    method: 'POST',
    headers,
    body: JSON.stringify(request.data),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Something went wrong. Please try again.' }));
    return Promise.reject(error);
  }
  return response.json() as Promise<RES>;
};
